export const STAR_BORDER_DEFAULT_SPEED = '6s';
export const STAR_BORDER_DEFAULT_THICKNESS = 1;
export const STAR_BORDER_ANIMATION_BOTTOM = 'star-movement-bottom';
export const STAR_BORDER_ANIMATION_TOP = 'star-movement-top';
